import { createContext, useContext } from "react";

/* The state one DisclosureRoot shares with its Trigger, Caret and Panel, so the
   trigger's aria-expanded / aria-controls stay wired to the panel wherever the
   two sit in the DOM. */
export interface DisclosureContextValue {
  readonly open: boolean;
  /** The panel's id; the trigger's `aria-controls` points at it. */
  readonly panelId: string;
  readonly toggle: () => void;
}

export const DisclosureContext = createContext<DisclosureContextValue | null>(
  null,
);

export function useDisclosureContext(part: string): DisclosureContextValue {
  const context = useContext(DisclosureContext);
  if (context === null) {
    throw new Error(`${part} must be rendered inside a DisclosureRoot.`);
  }
  return context;
}
